import axios from '@/libs/api.request'

/**
 * Get a list of exchange rates with the exchange rates to the other currency's.
 *
 * @param baseCurrencyCode
 *  Such as, CNY.
 */
export const getCurrencyExchangeRates = () => {
  return axios.request({
    url: `currencies/exchange-rates`,
    method: 'get'
  })
}

/**
 * Get all currencies available, this data can be used in select control for example.
 */
export const getCurrencyCodes = () => {
  return axios.request({
    url: 'currencies/codes',
    method: 'get'
  })
}
